import { createSelector, createFeatureSelector } from '@ngrx/store';

export const getSPOwnJobContext = createFeatureSelector('spOwnJobContext');

export const getOwnJobClaimType = createSelector(getSPOwnJobContext, (state: any) => state);
export const getOwnJobTeamleadersStaff = createSelector(getSPOwnJobContext, (state: any) => state);
export const getOwnJobTeamPositions = createSelector(getSPOwnJobContext, (state: any) => state);
